module.exports = __webpack_public_path__ + "img/where-to-use-md.6dc9108f.jpg";